import {useMemo} from "react";
import {StatisticsSearchCriteria} from "../model/statistics/statistics-search-criteria";
import {SiteEntity} from "../model/site";
import {StatisticsGroupWrapper} from "../model/statistics/statistics-group";
import {getRequiredObjectId} from "../model/entity";
import {siteStatisticsSelector} from "../store/statistics/selectors";
import {useSearchStatisticsQuery} from "../store/statistics/statistics-store";

export type UseGetSiteStatisticsProps = Omit<StatisticsSearchCriteria, 'siteIds'> & {
  site: string | SiteEntity,
  pickup?: boolean
}

export type UseGetSiteStatisticsResult = {
  statistics?: StatisticsGroupWrapper
  isLoading?: boolean,
  refetch?: any
}

export const useGetSiteStatistics = (props: UseGetSiteStatisticsProps): UseGetSiteStatisticsResult => {
  const {
    site,
    pickup,
    ...rest
  } = props;

  const siteId = useMemo(() => {
    return getRequiredObjectId(site)
  }, [site])

  const criteria: StatisticsSearchCriteria = useMemo(() => {
    return {
      ...rest,
      siteIds: [siteId],
    }
  }, [siteId, rest])

  const selectStatistics = useMemo(() => {
    return siteStatisticsSelector()
  }, []);

  const {statisticsBundle, isLoading, refetch} = useSearchStatisticsQuery(criteria, {
    selectFromResult: (result) => ({
      ...result,
      statisticsBundle: selectStatistics(result, siteId),
      isLoading: result.isLoading || result.isFetching,
    })
  });

  const siteStatistics = useMemo(() => {
    if (typeof pickup === 'undefined') {
      return statisticsBundle?.all
    } else if (pickup) {
      return statisticsBundle?.pickup
    } else {
      return statisticsBundle?.delivery
    }
  }, [pickup, statisticsBundle])

  return {
    statistics: siteStatistics,
    isLoading: isLoading,
    refetch: refetch,
  };
};
